<template>
  <div>
    <modal :id="modalId" :title="title">

      <div v-if="error" class="alert alert-danger text-center">
        {{ error }}
      </div>

      <div v-else>

        <div class="form-group row">
          <label class="col-sm-2 col-form-label" for="selected">Selected File:</label>
          <div class="col-sm-10">
            {{ uploadObject.name }}
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-2 col-form-label" for="report_type">Report Type:</label>
          <div class="col-sm-10">
            <select class="form-control" v-model="fields.report_type">
              <option v-for="type in reportTypes" :value="type">{{ type }}</option>
            </select>
          </div>
        </div>

        <div v-if="requestError" class="alert alert-danger text-center">
          {{ requestError }}
        </div>
        <div v-else-if="successMessage" class="alert alert-success text-center">
          {{ successMessage }}
        </div>

      </div>

      <template #footer>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-close"></i> Cancel</button>
        <button type="button" v-if="!error" class="btn btn-primary" @click="submit()" :disabled="formIsProcessing"><i class="fa fa-fw fa-save"></i> Submit</button>
      </template>

    </modal>
  </div>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'uploads-bulk-wf-export-modal'
    },

    // Form title.
    title: {
      type: String,
      default: "Export to Wright Flood"
    },

    // Claim id.
    claimId: {
      required: true,
      type: String
    },

    // Report type list.
    reportTypes: {
      type: Array,
      default: () => {return []}
    },

    // All file object list.
    uploadObjects: {
      type: Array,
      default: () => {return []}
    },

    // Selected IDs.
    uploadIds: {
      type: Array,
      default: () => {return []}
    },

  },

  data() {
    return {
      fields: {
        'report_type': '',
        'upload_id': '',
      },
      formIsProcessing: false,
      successMessage: '',
      requestError: '',
    }
  },

  /**
   * Computed values
   */
  computed: {

    uploadId() {
      if (this.uploadIds.length > 0) return this.uploadIds[0];
      return 0;
    },

    uploadObject() {
      if (this.uploadIds.length === 1) {
        let filtered = this.uploadObjects.filter(o => parseInt(o.id) === parseInt(this.uploadId));
        if (filtered.length > 0) return filtered[0];
      }
      return {};
    },

    error() {
      if (this.uploadIds.length === 0) {
        return 'No files selected';
      }
      if (this.uploadIds.length > 1) {
        return 'Please select only one report to export.';
      }
      // @todo Validate PDF file.
      return '';
    }

  },

  /**
   * Functions (methods).
   */
  methods: {

    init() {
      this.fields.report_type = this.reportTypes[0];
    },

    /**
     * Prepare form data
     */
    formData() {
      this.fields.upload_id = this.uploadId;
      const formData = new FormData();
      Object.keys(this.fields).forEach(fieldName => {
        const value = this.fields[fieldName] ? this.fields[fieldName] : '';
        formData.append(fieldName, value);
      });
      return formData;
    },

    /**
     * Submit form data
     */
    submit() {
      let formData = this.formData();
      formData.append('_method', "POST");
      this.requestError = '';
      this.successMessage = '';
      this.formIsProcessing = true;
      axios.post('/claims/' + this.claimId + '/uploads/wf-export', formData)
        .then(response => {
          if (!response.data.error) {
            this.successMessage = 'Exported successfully';
          } else {
            this.requestError = 'Unable to process request. ' + response.data.error;
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.requestError = 'Unable to process request: access denied.';
          } else {
            if (error.response.status === 422) {
              this.requestError = 'Unable to process request. ' + error.response.data.message;
            }
            else {
              this.requestError = 'Unable to process request.';
            }
          }
        })
        .finally(() => {
          this.formIsProcessing = false;
        });
    },

  },

  /**
   * Component initialization.
   */
  mounted () {
    this.init();
  },
}
</script>
